import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import NewsEdit             from "./NewsEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Filter               from "Dashboard/Components/Filter/Filter";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The News List
 * @returns {React.ReactElement}
 */
function NewsList() {
    const { fetch, load, loadFilter } = useList("news");

    const data = Store.useState("news");
    const { loading, canEdit, list, total, filters, sort } = data;

    const { deleteElem } = Store.useAction("news");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "newsID", elemID, "title");

    return <Main>
        <Header message="NEWS_NAME" icon="news">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Filter
                onFilter={loadFilter}
                values={filters}
                hasSearch
            />
            <Table
                fetch={load}
                sort={sort}
                none="NEWS_NONE_AVAILABLE"
                isLoading={loading}
                hasTabs
            >
                <TableHead>
                    <TableHeader field="publishTime"      message="GENERAL_DATE"        maxWidth="100" />
                    <TableHeader field="title"            message="GENERAL_TITLE"       isTitle grow="2" />
                    <TableHeader field="newsCategoryName" message="CATEGORIES_SINGULAR" />
                    <TableHeader field="showInHome"       message="NEWS_IN_HOME"        align="center" maxWidth="100" />
                    <TableHeader field="forNazar"         message="NEWS_IN_NAZAR"       align="center" maxWidth="100" />
                    <TableHeader field="showBefore"       message="ENTRIES_SHOW_BEFORE" align="center" maxWidth="110" />
                    <TableHeader field="status"           message="GENERAL_STATUS"      align="center" maxWidth="100" />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.newsID} elemID={elem.newsID}>
                        <TableCell message={elem.publishTimeDate}  />
                        <TableCell message={elem.title}            />
                        <TableCell message={elem.newsCategoryName} />
                        <TableCell message={elem.showInHomeText}   />
                        <TableCell message={elem.forNazarText}     />
                        <TableCell message={elem.showBeforeText}   />
                        <TableCell message={elem.statusName}       textColor={elem.statusColor} />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="NEWS_EDIT_TITLE"   />
                    <TableAction action="COPY"   message="NEWS_COPY_TITLE"   />
                    <TableAction action="DELETE" message="NEWS_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <NewsEdit
            open={action.isVCCE}
            isCopy={action.isCopy}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="NEWS_DELETE_TITLE"
            message="NEWS_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default NewsList;
